import { useQuery } from 'react-query';
import { parsePersonKey, personKeys } from '../cache-keys/personKeys';
import { useAPI } from '@axo/shared/data-access/provider';
import { insurance_api } from '@axo/shared/data-access/api';
import { queryFunction } from '../query-function';

export function useInsurance(
  personID: string | undefined | null,
  customerID?: string | undefined
) {
  const api = useAPI();
  const cacheKey = personKeys.insurance({
    personID: personID,
  });
  return useQuery(
    cacheKey,
    queryFunction(insurance_api.find(api), ({ queryKey }) => {
      const { personID } = parsePersonKey(queryKey);
      return { personID, customerID };
    }),
    {
      enabled: !!personID,
    }
  );
}
